<div class="card rounded-3">
  <div class="card-header">
    <h5 class="mb-0 text-primary fw-bold" translate>{{ title }}</h5>
  </div>
  <div class="card-body" *ngIf="items && items.length > 0">
    <div class="timeline stockTimeline margin-bottom-30">
      <div class="timeline-item" *ngFor="let item of items">
        <div class="timeline-badge">
          <div class="timeline-icon">
            <i class="icon-bubbles font-blue"></i>
          </div>
        </div>
        <div class="timeline-body">
          <div class="timeline-body-arrow"></div>
          <div class="timeline-body-head">
            <div class="timeline-body-head-caption">
              <span class="timeline-body-title font-blue">
                {{ item.date | date: 'dd/MM/yyyy HH:mm' }}
              </span>
              <span class="timeline-body-time font-grey-cascade">
                {{ item.userName }}
              </span>
            </div>
            <div class="timeline-body-head-actions"></div>
          </div>
          <div class="timeline-body-content">
            <span class="info-status badge rounded-pill text-wrap fs-7 p-2
             text-uppercase" [ngClass]="item.statusColorClass" [attr.data-status]="item.statusColorClass">
              {{ item.statusTranslationKey | translateAsync }}
            </span>
            <br />
            <br />
            <span class="font-grey-cascade wordBreak" *ngIf="item.comments">
              {{ item.comments }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body text-center" *ngIf="!items || items.length === 0">
    <p class="text-muted" translate>$general.noDataAvailable</p>
  </div>
</div>

